class ContentTypeConstants {
  public static readonly JSON: string = 'application/json';

  public static readonly PDF: string = 'application/pdf';

  public static readonly CSV: string = 'text/csv';
}

export default ContentTypeConstants;
